import React from "react";
import { Route, Switch } from "react-router";
import { RestrictedRoute } from "../utils/RestrictedRoute";
import ChecklistTemplatesTable from "../components/WorkshopPlanning/General/ChecklistTemplates/ChecklistTemplatesTable";
import ChecklistTemplatesCreation from "../components/WorkshopPlanning/General/ChecklistTemplates/ChecklistTemplatesCreation";
import ChecklistTemplatesTranslations from "../components/WorkshopPlanning/General/ChecklistTemplates/ChecklistTemplatesTranslations";
import { Permissions } from "../utils/Permissions";

export default function ChecklistTemplatesRouting(props) {
  const { currentIdentity, resources } = props;

  return (
    <>
      <RestrictedRoute
        path="/checklisttemplates"
        userPermissions={currentIdentity.permissions}
        routePermissions={[Permissions.WorkshopSettings]}
        resources={resources}
        render={() => {
          return <ChecklistTemplatesTable resources={resources} />;
        }}
      />
      <Switch>
        <Route
          exact
          path="/checklisttemplates/new"
          render={() => (
            <ChecklistTemplatesCreation
              resources={resources}
              defaultObjectType={currentIdentity.objectType}
              language={currentIdentity.culture.slice(0, 2)}
            />
          )}
        />

        <Route
          path="/checklisttemplates/:templateId"
          render={(props) => {
            const { templateId } = props.match.params;
            return (
              <>
                <ChecklistTemplatesCreation
                  resources={resources}
                  defaultObjectType={currentIdentity.objectType}
                  language={currentIdentity.culture.slice(0, 2)}
                  hasTranslationLicence={currentIdentity.hasTranslationLicence}
                  templateId={templateId}
                />

                <Route
                  path={`/checklisttemplates/:templateId/translations`}
                  render={() => (
                    <ChecklistTemplatesTranslations
                      resources={resources}
                      templateId={templateId}
                      hasTranslationLicence={currentIdentity.hasTranslationLicence}
                    />
                  )}
                />
              </>
            );
          }}
        />
      </Switch>
    </>
  );
}
